import React from 'react';

const Slides = ({ currentSlide }) => {
  const slides = [
    {
      id: 0,
      meta: "Architecture",
      title: "The Second Digital Brain",
      content: "Solving the continuity problem in agentic AI systems through Neuro Vector Memory.",
      subContent: "Scroll to explore the architecture."
    },
    {
      id: 1,
      meta: "Layer 01",
      title: "Episodic Cloud",
      content: "A vast, distributed cortex of raw experience. Emails, documents, and conversations are stored as contextual vectors.",
      subContent: "Like the human cortex, this layer holds the \"what\" — the specific facts and events of your digital life."
    },
    {
      id: 2,
      meta: "Layer 02",
      title: "Behavioral Core",
      content: "The dense gravity of personality. Stable patterns that dictate how problems are solved, not just what was said.",
      subContent: "Acting as the hippocampus and prefrontal cortex, this layer organizes experience into reusable strategies and decision-making policies."
    },
    {
      id: 3,
      meta: "Process",
      title: "Contextual Recall",
      content: "Retrieval is no longer keyword-based. It is a neuronal activation that links behavioral intent with episodic evidence.",
      subContent: "The system identifies the \"Behavioral Blueprint\" first, then lights up relevant memories to guide the agent's actions."
    },
    {
      id: 4,
      meta: "Vision",
      title: "Digital Continuity",
      content: "Agents that don't just process tasks, but evolve with you.",
      subContent: "Consistent. Personalized. Adaptive. The missing cognitive layer between reactive chatbots and true digital co-workers."
    }
  ];

  return (
    <>
      {/* Slide 1 */}
      <div className={`slide ${currentSlide === 0 ? 'active' : currentSlide > 0 ? 'exit' : ''}`} id="slide-0">
        <span className="meta">Architecture</span>
        <h1>The Second<br />Digital Brain</h1>
        <p>Solving the continuity problem in agentic AI systems through <span className="highlight">Neuro Vector Memory</span>.</p>
        <p style={{ fontSize: '0.9rem', color: '#777', marginTop: '-20px' }}>Scroll to explore the architecture.</p>
      </div>

      {/* Slide 2 */}
      <div className={`slide ${currentSlide === 1 ? 'active' : currentSlide > 1 ? 'exit' : ''}`} id="slide-1">
        <span className="meta">Layer 01</span>
        <h2>Episodic Cloud</h2>
        <p>A vast, distributed cortex of raw experience. Emails, documents, and conversations are stored as <span className="highlight">contextual vectors</span>.</p>
        <p style={{ fontSize: '0.95rem' }}>Like the human cortex, this layer holds the "what" — the specific facts and events of your digital life.</p>
      </div>

      {/* Slide 3 */}
      <div className={`slide ${currentSlide === 2 ? 'active' : currentSlide > 2 ? 'exit' : ''}`} id="slide-2">
        <span className="meta">Layer 02</span>
        <h2>Behavioral Core</h2>
        <p>The dense gravity of personality. Stable patterns that dictate <span className="highlight">how</span> problems are solved, not just what was said.</p>
        <p style={{ fontSize: '0.95rem' }}>Acting as the hippocampus and prefrontal cortex, this layer organizes experience into reusable strategies and decision-making policies.</p>
      </div>

      {/* Slide 4 */}
      <div className={`slide ${currentSlide === 3 ? 'active' : currentSlide > 3 ? 'exit' : ''}`} id="slide-3">
        <span className="meta">Process</span>
        <h2>Contextual Recall</h2>
        <p>Retrieval is no longer keyword-based. It is a <span className="highlight">neuronal activation</span> that links behavioral intent with episodic evidence.</p>
        <p style={{ fontSize: '0.95rem' }}>The system identifies the "Behavioral Blueprint" first, then lights up relevant memories to guide the agent's actions.</p>
      </div>

      {/* Slide 5 */}
      <div className={`slide ${currentSlide === 4 ? 'active' : currentSlide > 4 ? 'exit' : ''}`} id="slide-4">
        <span className="meta">Vision</span>
        <h1>Digital<br />Continuity</h1>
        <p>Agents that don't just process tasks, but <span className="highlight">evolve with you</span>.</p>
        <p style={{ fontSize: '0.95rem' }}>Consistent. Personalized. Adaptive. The missing cognitive layer between reactive chatbots and true digital co-workers.</p>
      </div>
    </>
  );
};

export default Slides;
